import { render, staticRenderFns } from "./BarcodeCompanies.vue?vue&type=template&id=66f64fab"
import script from "./BarcodeCompanies.vue?vue&type=script&lang=ts"
export * from "./BarcodeCompanies.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports